import styled from "styled-components";

export const MoreOptionWrapper = styled.div`
  position: relative;
  svg {
    width: 24px;
    cursor: pointer;
    fill: #00baf2;
  }
  .options {
    position: absolute;

    margin: 0px;
    top: 100%;
    min-width: 100%;
    right: 0;
    background-color: #fff;
    position: absolute;
    visibility: hidden;
    opacity: 0;
    z-index: 10;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    min-width: 150px;
    border-radius: 8px;
    &.top{
      bottom: 100%;
      top: auto;
      &::after{
        top: calc(100% + 7px) !important;
        border-color: #fff  transparent transparent  transparent !important;
      }
    }
    &.open {
      visibility: visible;
      opacity: 1;
      ul {
        padding: 10px 0px;
        li {
          text-align: left;
          padding: 4px 20px;
          /* border-bottom: 1px solid #33333326; */
          text-transform: uppercase;
          cursor: pointer;
          &:last-child {
            border-bottom: none;
          }
          &:hover{
            background-color:  #33333326;
          }
        }
      }
      &::after {
  content: "";
  position: absolute;
  top: -7px;
  right: 12px;
  transform: translateY(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
}
    }
  }
`;
